/* =========================================================
   PCA — DESIGN F 専用の差分データ
   shared/content.js の CONTENT に上書きマージして使う。
   共有CONTENTは変更しない（A〜E案への波及防止）。

   ※掲載URL・画像は 2026-07-04 に全件実在確認済み
     （コレクション/検索は404・0件なし、画像はPNG実体を確認）
   ※レビュー・件数・キャンペーンの創作は禁止（BRIEF_COMMON.md）
   ========================================================= */
const CONTENT_F = {
  /* LINE運用停止につきLINE文言を除去したアナウンス */
  "ANNOUNCE": "¥3,980以上で全国送料無料",

  /* PCA公式ロゴ（本店の実アセット・花型バッジ） */
  "LOGO": "https://casebypca.com/cdn/shop/files/PCA_7633da57-f167-4507-9328-f174f994d367.png?v=1754470024&width=240",

  /* 黒トップバー中央のアナウンス（LINEは除外・実在する訴求のみ・ロテーション） */
  "TOPBAR_MSGS": [
    "¥3,980以上で全国送料無料",
    "アクセサリー 2点10%OFF・3点15%OFF・4点20%OFF"
  ],

  /* ヘッダー機種メガナビ（本店の実コレクション構成・全リンク200確認済み 2026-07-05）
     iPhone 18 は「無印」コレクションが未作成のため、親項目はurlを持たせず
     サブメニュー(Pro / Pro Max)を開くためだけの親見出しとして扱う
     （f-app.js header() 側でurl無し=クリックで遷移しない仕様、2026-09-12）。
     iPhone Duo は2026-09-23にクライアント指示でiPhone 18サブメニュー末尾へ追加。 */
  "NAV_MENU": [
    { "label": "iPhone 18", "sub": [
      { "label": "iPhone 18 Pro", "url": "https://casebypca.com/collections/iphone-18-pro" },
      { "label": "iPhone 18 Pro Max", "url": "https://casebypca.com/collections/iphone-18-pro-max" },
      { "label": "iPhone Duo", "url": "https://casebypca.com/collections/iphoneduo" }
    ]},
    { "label": "iPhone 17", "url": "https://casebypca.com/collections/iphone-17", "sub": [
      { "label": "iPhone 17", "url": "https://casebypca.com/collections/iphone-17" },
      { "label": "iPhone 17 Pro", "url": "https://casebypca.com/collections/iphone-17-pro" },
      { "label": "iPhone 17 Pro MAX", "url": "https://casebypca.com/collections/iphone-17-pro-max" },
      { "label": "iPhone 17 Air", "url": "https://casebypca.com/collections/iphone-17-air" }
    ]},
    { "label": "iPhone 16", "url": "https://casebypca.com/collections/iphone16", "sub": [
      { "label": "iPhone 16", "url": "https://casebypca.com/collections/iphone16" },
      { "label": "iPhone 16 Pro", "url": "https://casebypca.com/collections/iphone16pro" },
      { "label": "iPhone 16 Pro MAX", "url": "https://casebypca.com/collections/iphone16promax" },
      { "label": "iPhone 16 Plus", "url": "https://casebypca.com/collections/iphone16plus" },
      { "label": "iPhone 16e", "url": "https://casebypca.com/collections/iphone-16e" }
    ]},
    { "label": "iPhone 15", "url": "https://casebypca.com/collections/iphone15", "sub": [
      { "label": "iPhone 15", "url": "https://casebypca.com/collections/iphone15" },
      { "label": "iPhone 15 Pro", "url": "https://casebypca.com/collections/iphone-15-pro" },
      { "label": "iPhone 15 Pro MAX", "url": "https://casebypca.com/collections/iphone-15-pro-max" },
      { "label": "iPhone 15 Plus", "url": "https://casebypca.com/collections/iphone-15-plus" }
    ]},
    { "label": "iPhone 14", "url": "https://casebypca.com/collections/iphone-14", "sub": [
      { "label": "iPhone 14", "url": "https://casebypca.com/collections/iphone-14" },
      { "label": "iPhone 14 Pro", "url": "https://casebypca.com/collections/iphone-14-pro" },
      { "label": "iPhone 14 Pro MAX", "url": "https://casebypca.com/collections/iphone-14-pro-max" },
      { "label": "iPhone 14 Plus", "url": "https://casebypca.com/collections/iphone-14-plus" }
    ]},
    { "label": "iPhone 13", "url": "https://casebypca.com/collections/iphone-13", "sub": [
      { "label": "iPhone 13", "url": "https://casebypca.com/collections/iphone-13" },
      { "label": "iPhone 13 Pro", "url": "https://casebypca.com/collections/iphone-13-pro" },
      { "label": "iPhone 13 Pro MAX", "url": "https://casebypca.com/collections/iphone-13-pro-max" },
      { "label": "iPhone 13 mini", "url": "https://casebypca.com/collections/iphone-13-mini" }
    ]},
    { "label": "iPhone 12", "url": "https://casebypca.com/collections/iphone-12", "sub": [
      { "label": "iPhone 12", "url": "https://casebypca.com/collections/iphone-12" },
      { "label": "iPhone 12 Pro", "url": "https://casebypca.com/collections/iphone-12-pro" },
      { "label": "iPhone 12 Pro MAX", "url": "https://casebypca.com/collections/iphone-12-pro-max" },
      { "label": "iPhone 12 mini", "url": "https://casebypca.com/collections/iphone-12-mini" }
    ]},
    { "label": "iPhone 11", "url": "https://casebypca.com/collections/iphone-11", "sub": [
      { "label": "iPhone 11", "url": "https://casebypca.com/collections/iphone-11" },
      { "label": "iPhone 11 Pro", "url": "https://casebypca.com/collections/iphone-11-pro" },
      { "label": "iPhone 11 Pro MAX", "url": "https://casebypca.com/collections/iphone-11-pro-max" }
    ]},
    { "label": "iPhone X", "url": "https://casebypca.com/collections/iphone-x", "sub": [
      { "label": "iPhone X", "url": "https://casebypca.com/collections/iphone-x" },
      { "label": "iPhone XS", "url": "https://casebypca.com/collections/iphone-xs" },
      { "label": "iPhone XS MAX", "url": "https://casebypca.com/collections/iphone-xs-max" },
      { "label": "iPhone XR", "url": "https://casebypca.com/collections/iphone-xr" }
    ]},
    { "label": "iPhone 7 / 8 / SE", "url": "https://casebypca.com/collections/iphone7-8-se-se2", "sub": [
      { "label": "iPhone 7 / iPhone 8", "url": "https://casebypca.com/collections/iphone7-8-se-se2" },
      { "label": "iPhone 7 Plus / 8 Plus", "url": "https://casebypca.com/collections/iphone-7-plus-iphone-8-plus" },
      { "label": "iPhone SE / SE2 / SE3", "url": "https://casebypca.com/collections/iphone-se-iphone-se2-iphone-se3" }
    ]},
    { "label": "カタログ", "url": "https://casebypca.com/collections/all", "sub": [] }
  ],

  /* スライダーバナー: iPhone 18 Pro シリーズ → iPhone Duo → お急ぎ発送（クライアント指示・2026-09-23差し替え）
     従来の ネオン/Magnet/カスタムNAME の3枚を削除し、iPhone 18 Pro / iPhone Duo を先頭2枚に追加。
     お急ぎ発送バナーは内容そのまま・3枚目へ移動。
     label=スライド上のキャプション文言、alt=img alt属性（アクセシビリティ用の別文言、2026-09-23追加）。 */
  "HERO_SLIDES": [
    {
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/iphone18.png?v=1790114359",
      "link": "https://casebypca.com/collections/iphone-18-pro",
      "label": "iPhone 18 Pro シリーズ",
      "alt": "iPhone 18 Pro・iPhone 18 Pro Max 対応ケース"
    },
    {
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/iphoneduo.png?v=1790114328",
      "link": "https://casebypca.com/collections/iphoneduo",
      "label": "iPhone Duo",
      "alt": "iPhone Duo 対応ケース"
    },
    {
      /* お急ぎ発送バナー（クライアント指示 2026-08-17・2026-09-23に3枚目へ移動、内容は変更なし）
         「すぐ発送」は即日発送と誤読されるため、表記は「2〜3日以内に発送」で固定。 */
      "image": (typeof window !== 'undefined' && window.PCA_F_ASSETS && window.PCA_F_ASSETS.slideQuickShip) || "https://casebypca.com/cdn/shop/t/29/assets/f-slide-quickship.png",
      "link": "https://casebypca.com/collections/quick-ship",
      "label": "2〜3日以内に発送"
    }
  ],

  /* 機種選択チップ（各世代 無印→Pro→Pro Maxの小さい順・クライアント確定順・2026-07-15）
     iPhone 18 Pro / Pro Max は2026-09-12にコレクション公開済みのため先頭に追加（実在URL 200確認済み）
     iPhone Duo は2026-09-23にクライアント指示でiPhone 18 Pro Maxの直後へ追加 */
  "MODEL_CHIPS": [
    { "label": "iPhone 18 Pro", "url": "https://casebypca.com/collections/iphone-18-pro" },
    { "label": "iPhone 18 Pro Max", "url": "https://casebypca.com/collections/iphone-18-pro-max" },
    { "label": "iPhone Duo", "url": "https://casebypca.com/collections/iphoneduo" },
    { "label": "iPhone 17", "url": "https://casebypca.com/collections/iphone-17" },
    { "label": "iPhone 17 Pro", "url": "https://casebypca.com/collections/iphone-17-pro" },
    { "label": "iPhone 17 Pro Max", "url": "https://casebypca.com/collections/iphone-17-pro-max" },
    { "label": "iPhone 16", "url": "https://casebypca.com/collections/iphone16" },
    { "label": "iPhone 16 Pro", "url": "https://casebypca.com/collections/iphone16pro" },
    { "label": "iPhone 16 Pro Max", "url": "https://casebypca.com/collections/iphone16promax" },
    { "label": "iPhone 15", "url": "https://casebypca.com/collections/iphone15" },
    { "label": "iPhone 15 Pro", "url": "https://casebypca.com/collections/iphone-15-pro" },
    { "label": "iPhone 15 Pro Max", "url": "https://casebypca.com/collections/iphone-15-pro-max" },
    { "label": "iPhone 14", "url": "https://casebypca.com/collections/iphone-14" },
    { "label": "iPhone 14 Pro", "url": "https://casebypca.com/collections/iphone-14-pro" },
    { "label": "iPhone 14 Pro Max", "url": "https://casebypca.com/collections/iphone-14-pro-max" },
    { "label": "iPhone 13", "url": "https://casebypca.com/collections/iphone-13" },
    { "label": "iPhone 12", "url": "https://casebypca.com/collections/iphone-12" }
  ],

  /* "気分"で選ぶ♪（クライアント確定6項目・専用mood_*コレクション・全URL 200確認済み 2026-07-15） */
  "MOODS": [
    { "emoji": "🎀", "label": "大人かわいい", "url": "https://casebypca.com/collections/mood_otona-kawaii" },
    { "emoji": "📸", "label": "SNS映え", "url": "https://casebypca.com/collections/mood_sns-bae" },
    { "emoji": "💄", "label": "韓国っぽ", "url": "https://casebypca.com/collections/mood_korean" },
    { "emoji": "💼", "label": "オフィスでも◎", "url": "https://casebypca.com/collections/mood_office" },
    { "emoji": "🫧", "label": "クリア・透明感", "url": "https://casebypca.com/collections/クリア" },
    { "emoji": "🖤", "label": "すっきりシンプル", "url": "https://casebypca.com/collections/simple" }
  ],

  /* 推しカラーで選ぶ（Canva「できたら」項目・全色検索1件以上を確認済み） */
  "COLORS": [
    { "label": "ピンク", "hex": "#FF9EC6", "url": "https://casebypca.com/search?q=ピンク" },
    { "label": "パープル", "hex": "#BC93F9", "url": "https://casebypca.com/search?q=パープル" },
    { "label": "ブルー", "hex": "#79BDF7", "url": "https://casebypca.com/search?q=ブルー" },
    { "label": "グリーン", "hex": "#7FDE9A", "url": "https://casebypca.com/search?q=グリーン" },
    { "label": "イエロー", "hex": "#F6E163", "url": "https://casebypca.com/search?q=イエロー" },
    { "label": "オレンジ", "hex": "#FFB37E", "url": "https://casebypca.com/search?q=オレンジ" },
    { "label": "レッド", "hex": "#FF6B6B", "url": "https://casebypca.com/search?q=レッド" },
    { "label": "ホワイト", "hex": "#FFFFFF", "url": "https://casebypca.com/search?q=ホワイト" },
    { "label": "グレー", "hex": "#C7C9CE", "url": "https://casebypca.com/search?q=グレー" },
    { "label": "ブラック", "hex": "#1C1C1C", "url": "https://casebypca.com/search?q=ブラック" }
  ],

  /* 記事（casebypca.com公式ブログの公開記事のみ・新しい順）
     build_blog_data.py が Atomフィードから自動生成・手編集しない。
     ブラウザ表示時は live-data.js が本店Atomフィードから再取得して差し替える。 */
  // >>> ARTICLES_AUTO (build_blog_data.py が自動生成・手編集しない) >>>
  "ARTICLES": [
    {
      "title": "デザインも機能も充実！おすすめGalaxyケース特集",
      "date": "2026.08.21",
      "url": "https://casebypca.com/blogs/ニュース/galaxy-case-collection",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/Galaxy___800x800_a0eb7c2e-85e5-402b-9ce2-628f3f0642f1.png?v=1787269682&width=800"
    },
    {
      "title": "大人かわいい花柄！最新フラワーiPhoneケース特集",
      "date": "2026.08.16",
      "url": "https://casebypca.com/blogs/ニュース/flower-iphone-case",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/flower_lead_800x800_rev2_22697e42-81fe-4e7a-a7ae-78c7b5385b41.png?v=1786923671&width=800"
    },
    {
      "title": "きゅんとかわいい！最新ハート＆リボンモチーフiPhoneケース特集",
      "date": "2026.08.08",
      "url": "https://casebypca.com/blogs/ニュース/heart-ribbon-iphone-case",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/1_c9faffc2-ad08-4299-a0c9-7bcdd0956805.png?v=1786146263&width=800"
    },
    {
      "title": "夏にぴったりのiPhoneケース！最新なブルー特集",
      "date": "2026.07.30",
      "url": "https://casebypca.com/blogs/ニュース/summer-blue-case",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/1_2c6c9667-38ab-4276-9731-47a47ab62752.png?v=1785408862&width=800"
    }
  ],
  // <<< ARTICLES_AUTO <<<
  "BLOG_URL": "https://casebypca.com/blogs/ニュース",

  /* 安心バッジ（LINE項目を除いた3枚・アイコン付き） */
  "BADGES": [
    {
      "icon": "🚚",
      "title": "¥3,980以上で送料無料",
      "text": "お買い上げ¥3,980以上で全国送料無料。"
    },
    {
      "icon": "📦",
      "title": "お届け目安 7〜14営業日",
      "text": "ご注文後、通常7〜14営業日でお届けします。",
      "link_label": "配送について",
      "link": "https://casebypca.com/policies/shipping-policy"
    },
    {
      "icon": "🔄",
      "title": "返品・交換",
      "text": "返品・交換の条件はポリシーをご確認ください。",
      "link_label": "返品ポリシーを見る",
      "link": "https://casebypca.com/policies/refund-policy"
    }
  ],

  /* お盆休暇のお知らせ（テキスト版・スライドバナー上部・B領域・LOCKED_KEYS対象外・2026-07-21）
     - hide_after 到来で TOP は自動非表示（app.js obonNotice）。
     - 2026-08-13 クライアント指示で撤去。hide_after を過去日時にして非表示化（本文は保持）。
     - 画像バナー版(NOTICE)と併存（クライアント2026-07-23指示・重複OK）。 */
  "OBON_NOTICE": {
    "title": "【お盆期間の営業・発送について】",
    "body_html": "<p>2026年8月8日(土)〜8月16日(日)までお盆休暇となります。この期間は発送業務が休止となりますので、あらかじめご了承ください。</p><p>通常、ご注文から発送まで<strong>【7〜14営業日前後】</strong>お時間をいただいておりますが、7月後半〜8月前半にご注文いただいた商品につきましては、お盆期間と重なるため配送会社の荷物増加や交通状況の影響により、通常よりお時間をいただく場合がございます。</p><p><u><strong>発送業務は8月17日(月)より順次再開</strong></u>いたします。ご不便をおかけいたしますが、ご理解のほどよろしくお願いいたします。</p><p>☘️ご注文前に <a href=\"https://casebypca.com/pages/shoppingguide\">ショッピングガイド</a> を必ずご確認くださいませ。</p>",
    "hide_after": "2026-08-13T00:00:00+09:00"
  },
  /* お盆期間のお知らせ（画像バナー・LIVE準拠・クライアント指示 2026-07-23）
     - 画像=Shopify Files attention.png（LIVE 20260715 と同一）。
     - SALE(まとめ買い)バナー直下に .notice-band で表示（app.js notice()）。
     - 2026-08-13 クライアント指示で撤去。キー名を NOTICE_OFF にして描画停止（再掲は "NOTICE" に戻すだけ）。 */
  "NOTICE_OFF": {
    "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/attention.png?v=1784720164",
    "link": "https://casebypca.com/pages/summer_info"
  },

  /* カテゴリーナビ（iPhone以外のデバイス/アクセサリー導線・2026-07-21 クライアント指示②）
     - 表示位置: MODEL_CHIPS(あなたのiPhoneから探す) と MOODS("気分"で選ぶ) の間
     - image は theme asset（window.PCA_F_ASSETS.catnav 経由）＝index.liquid が注入
     - 見本UI準拠で見出しなし・アイコン列のみ
     - LOCKED_KEYS対象外の新規キー（check_client_lock ゲートに影響しない） */
  "CATEGORY_NAV": [
    { "key": "galaxy",  "label": "Galaxy対応ケース",       "url": "https://casebypca.com/collections/galaxy" },
    { "key": "pixel",   "label": "Google Pixel対応ケース", "url": "https://casebypca.com/collections/google-pixel" },
    { "key": "ipad",    "label": "iPadケース",             "url": "https://casebypca.com/collections/ipadcase" },
    { "key": "airpods", "label": "AirPodsケース",          "url": "https://casebypca.com/collections/airpodscase" },
    { "key": "acc",     "label": "その他アクセサリー",     "url": "https://casebypca.com/collections/acc" }
  ],

  /* LINE運用停止：共有CONTENTのLINE_URLを無効化（このF案ではLINE導線を一切出さない） */
  "LINE_URL": null,

  /* ================================================================
     以下、クライアント確定値の反映（2026-07-15指示）:
     - DISCOUNT: まとめ買い帯のリンク先=アクセサリー
     - TASTES: テイスト12件（素材・機能軸）
     sharedからの逆戻り防止のため content_f.js に override。
     SNS/FOOTER_LINKS 等の他キーは今回スコープ外＝shared側に委ねる。
     ================================================================ */

  /* まとめ買い割引バナー（アクセサリー限定を明示・リンク先=アクセサリー・クライアント指示 2026-07-15）
     2026-09-23・クライアント指示: badgeをオレンジ系バッジ（左上寄り）として分離。
     textは同日中に再度指示があり、改行なしの1行（4点20%OFFの階層を含む）へ変更
     （背景色・角丸・リンク先・カード高さは無変更）。 */
  "DISCOUNT": {
    "badge": "買うほどおトク！",
    "text": "2点10%OFF・3点15%OFF・4点20%OFF",
    "link": "https://casebypca.com/collections/acc"
  },

  /* お急ぎ発送バナー（TOP・SALE帯直下・クライアント指示 2026-08-13）
     - 通常は7〜14営業日前後。在庫がある一部商品だけ2〜3日以内に発送できる旨を明記する。
     - 2026-09-23・クライアント指示によりbadgeを「すぐ発送」に変更（既存の青バッジデザインを流用・左上寄り）。
       旧来「即日発送と誤読される」ため避けていた表記だが、今回は明示指示のため反映（要再確認事項として記録）。 */
  "QUICKSHIP": {
    "badge": "すぐ発送",
    "text": "在庫がある商品は2〜3日以内に発送",
    "link": "https://casebypca.com/collections/quick-ship"
  },

  /* テイストで探す（クライアント確定12件・素材・機能軸） */
  "TASTES": [
    { "label": "マグネット対応ケース",       "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/Sa5c882219df5407a8577d62acb877b274.webp?v=1781453480", "url": "https://casebypca.com/collections/magsafe" },
    { "label": "グリップ・ストラップ付き",   "image": "https://casebypca.com/cdn/shop/files/Sbfa59825d16741e09cb30babb5526bb21.webp?v=1774426704&width=600", "url": "https://casebypca.com/collections/%E3%83%9B%E3%83%AB%E3%83%80%E3%83%BC%E4%BB%98%E3%81%8D" },
    { "label": "手帳型・ブックタイプ",       "image": "https://casebypca.com/cdn/shop/files/Scf1349f0b9a64b4282955d6c151cab05x.webp?v=1769963497&width=600", "url": "https://casebypca.com/collections/bookstyle" },
    { "label": "名入れ・カスタム",           "image": "https://casebypca.com/cdn/shop/files/S7a5cfb9216a6403ba7ed37cdcff3da59w.webp?v=1756110464&width=600", "url": "https://casebypca.com/collections/custom" },
    { "label": "本革 / レザー調",            "image": "https://casebypca.com/cdn/shop/files/Sb4154fa2921e4abda18abaccbbb44e82N.webp?v=1763370325&width=600", "url": "https://casebypca.com/collections/leather" },
    { "label": "ショルダーストラップ付き",   "image": "https://casebypca.com/cdn/shop/files/S2f714b643b564b2e9cde6f8ca3496d15z.webp?v=1779719116&width=600", "url": "https://casebypca.com/collections/shoulderstrap" },
    { "label": "グラデ",                     "image": "https://casebypca.com/cdn/shop/files/Sf539a042a9604c988e75b77f937c9a35y.webp?v=1774630594&width=600", "url": "https://casebypca.com/collections/gradation" },
    { "label": "フラワー",                   "image": "https://casebypca.com/cdn/shop/files/S5010c06cd1964263b04420a4643ff76aP.webp?v=1767687160&width=600", "url": "https://casebypca.com/collections/フラワー" },
    { "label": "フルーツ",                   "image": "https://casebypca.com/cdn/shop/files/S1b5311fcd8634fa9a766f4e19414409d1.webp?v=1768647634&width=600", "url": "https://casebypca.com/collections/フルーツ" },
    { "label": "ドット",                     "image": "https://casebypca.com/cdn/shop/files/Sff6a87442b8b4a1594d38c6860337f8bE.webp?v=1751898105&width=600", "url": "https://casebypca.com/collections/ドット" },
    { "label": "リボン",                     "image": "https://casebypca.com/cdn/shop/files/S5906ba73241c4c51ba7d41dd0288039an.webp?v=1782583563&width=600", "url": "https://casebypca.com/collections/リボン" },
    { "label": "キラキラ・ビジュー",         "image": "https://casebypca.com/cdn/shop/files/S70013c4699ad42c292ed175962b4a37f5.webp?v=1770465705&width=600", "url": "https://casebypca.com/collections/glitter-bijou" }
  ],


  /* 人気RANKING TOP10 の下敷きスナップショット（build_ranking_data.py が自動生成・手編集しない）
     - データ源 = casebypca.com/collections/ranking（クライアントがコレクションで順位管理）
     - 表示時に live-data.js が同エンドポイントから再取得して差し替える（三段構え）
     - app.js の ranking() は C.RANKING_BAKED があれば優先、無ければ shared/content.js の RANKING を使う */
  // >>> RANKING_AUTO (build_ranking_data.py が自動生成・手編集しない) >>>
  "RANKING_BAKED": [
    {
      "title": "【ふんわりチーク】くすみグラデ iPhoneケース ストラップ付き 韓国風 透明 スマホカバー グラデーション かわいい",
      "handle": "241216",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF.gif?v=1783685821",
      "url": "https://casebypca.com/products/241216",
      "review_count": 4
    },
    {
      "title": "【ネオンカラー】マットクリア iPhoneケース｜ロープストラップ付き Magnet内蔵 耐衝撃 韓国風 スマホカバー",
      "handle": "250803",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF_1.gif?v=1783686004",
      "url": "https://casebypca.com/products/250803",
      "review_count": 5
    },
    {
      "title": "【Magnet内蔵】ポップカラー ロープストラップ iPhoneケース スマホカバー ネオン",
      "handle": "250215",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/Sf2d1ab620c2c4fbf9756204eea6f1a26V.webp?v=1774426767",
      "url": "https://casebypca.com/products/250215",
      "review_count": 6
    },
    {
      "title": "琥珀 マーブルグリップ iPhoneケース",
      "handle": "250622",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF_3.gif?v=1783686446",
      "url": "https://casebypca.com/products/250622",
      "review_count": 1
    },
    {
      "title": "【アニマルシリーズ】ブルー×レオパード柄 スマホケース｜iPhone対応 ヒョウ柄 韓国風",
      "handle": "アニマルシリーズ-ブルー-レオパード柄-光沢クリア-スマホケース-iphone対応-250909",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF_5.gif?v=1783686112",
      "url": "https://casebypca.com/products/アニマルシリーズ-ブルー-レオパード柄-光沢クリア-スマホケース-iphone対応-250909",
      "review_count": 5
    },
    {
      "title": "【スポーティで可愛い♪ 】ネオンアクセント マットブラック iPhoneケース｜ ストラップ付き ストリート映え",
      "handle": "240411",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF_6.gif?v=1783686212",
      "url": "https://casebypca.com/products/240411",
      "review_count": 0
    },
    {
      "title": "ちゅるんと可愛い！クリア iPhoneケース ストラップ付き 透明 耐衝撃",
      "handle": "260510",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF_4.gif?v=1783686035",
      "url": "https://casebypca.com/products/260510",
      "review_count": 2
    },
    {
      "title": "【肩掛け・斜め掛け用】iPhone対応ケース カードポケット×ストラップ付き ｜",
      "handle": "240805",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF_7.gif?v=1783686399",
      "url": "https://casebypca.com/products/240805",
      "review_count": 1
    },
    {
      "title": "【Magnet内蔵】ネオン グラデーションカラー TPU 耐衝撃 おしゃれ ビビッドカラー グリップ付き スマホケース｜iPhone対応",
      "handle": "251230",
      "price": "3980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF_8.gif?v=1783686469",
      "url": "https://casebypca.com/products/251230",
      "review_count": 3
    },
    {
      "title": "【Magnet対応】スケルトンガード 耐衝撃クリア × ストラップ スマホケース｜iPhone対応",
      "handle": "240824",
      "price": "3980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/PCAGIF_9.gif?v=1783686492",
      "url": "https://casebypca.com/products/240824",
      "review_count": 0
    }
  ],
  // <<< RANKING_AUTO <<<

  /* NEW ARRIVAL の下敷きスナップショット（日次自動生成・build_new_arrivals_data.pyが更新）
     ブラウザ表示時に live-data.js が本店products.jsonからさらに最新へ差し替える */
  // >>> NEW_ARRIVALS_AUTO (build_new_arrivals_data.py が自動生成・手編集しない) >>>
  "NEW_ARRIVALS_BAKED": [
    {
      "title": "【iPadケース】大人かわいい マットカラー リング付き iPadケース｜ミニマル・おしゃれ",
      "handle": "261123",
      "price": "4980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/S61627b4340544b449745be0785ab9be78.webp?v=1787286878",
      "url": "https://casebypca.com/products/261123"
    },
    {
      "title": "【スマホストラップ】フリルシュシュ風 ロングショルダーストラップ 全5色 レトロ・フェミニン・トレンド",
      "handle": "261122",
      "price": "3500",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/S571f32e1b4c14176beeba14efb5c2485Q.webp?v=1786178324",
      "url": "https://casebypca.com/products/261122"
    },
    {
      "title": "【Galaxy対応】マグネット内蔵スタンドリング付きケース 全5色 ポップ・スタイリッシュ・カラフル",
      "handle": "261121",
      "price": "3980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/Sb869817d67da47df90bab2695e7b06d5C.webp?v=1787279160",
      "url": "https://casebypca.com/products/261121"
    },
    {
      "title": "【Galaxy対応】カラフルバイカラー マグネット内蔵リングホルダー付きケース 全7色 ポップ・カジュアル・レトロ",
      "handle": "261120",
      "price": "3980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/S8b23506c94e84f70aee034e8cfd45190C.webp?v=1786178311",
      "url": "https://casebypca.com/products/261120"
    },
    {
      "title": "バイカラー ライトニングデザイン クリア iPhoneケース",
      "handle": "261118",
      "price": "3980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/A231944482b3e4d5aa0bd40ab679cee02N.webp?v=1786178310",
      "url": "https://casebypca.com/products/261118"
    },
    {
      "title": "韓国風 シェル チェック柄 ダイヤパターン iPhoneケース",
      "handle": "261117",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/A57071e1453cd441280162208786c16870.webp?v=1786178308",
      "url": "https://casebypca.com/products/261117"
    },
    {
      "title": "【スマホショルダー】マグネット着脱式 編み込みロープ｜斜め掛け・手ぶら・カラフル・落下防止",
      "handle": "261116",
      "price": "3500",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/Sca7bce5a247940c9a9930e929a4479ddq.webp?v=1786178307",
      "url": "https://casebypca.com/products/261116"
    },
    {
      "title": "【Galaxy 対応】ブラックリボン チェーン付き マグネット耐衝撃ハードケース",
      "handle": "261115",
      "price": "2980",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/S63d1ad40a77a4f88bbed14c604edf488P.webp?v=1786178307",
      "url": "https://casebypca.com/products/261115"
    }
  ],
  // <<< NEW_ARRIVALS_AUTO <<<

  /* みんなのレビュー（実レビューの最新5件）。
     下の配列は build_reviews_data.py が Judge.me から取得して自動更新する。
     ※Shopify本番テーマでは Judge.me の「レビューカルーセル」ウィジェットを置けば
       新着レビューが常時自動表示される（真の随時更新）。ここは静的プレビュー用。 */
  // >>> REVIEWS_AUTO (build_reviews_data.py が自動生成・手編集しない) >>>
  "REVIEWS": [
    {
      "stars": 5,
      "quote": "すごくお気に入りです。 機種変更した時には また購入したいと思います。",
      "product": "ネオンカラー",
      "url": "https://casebypca.com/products/250803"
    },
    {
      "stars": 4,
      "quote": "すごく可愛いです！！ ちょっと指紋がつきやすいかな。でもそれは素材上仕方ないですが…",
      "product": "ふんわりチーク",
      "url": "https://casebypca.com/products/241216"
    },
    {
      "stars": 5,
      "quote": "１７ｅのケースがなかなか見つからず１６ｅのケースを買いましたが、推しの色のケースが見つかったので大満足です。スマホが目立って気に入っています。",
      "product": "ちゅるんと可愛い！クリア iPhoneケース",
      "url": "https://casebypca.com/products/260510"
    },
    {
      "stars": 5,
      "quote": "実物もめちゃめちゃ可愛かった！",
      "product": "ネオンカラー",
      "url": "https://casebypca.com/products/250803"
    },
    {
      "stars": 5,
      "quote": "めちゃくちゃかわいくて気に入ってます。差し込みで充電するときはストラップの接続部分が邪魔をして入れにくいですが、それ以外は問題なしです。",
      "product": "ふんわりチーク",
      "url": "https://casebypca.com/products/241216"
    },
    {
      /* 2026-09-24・クライアント指示で追加（Worker障害時フォールバックをPC 3列×2段=6件に揃えるため）。
         この商品はRANKING_BAKED/NEW_ARRIVALS_BAKEDに無いため、imageを直接指定する
         （f-app.js側は r.image があれば優先し、無ければ従来通りfindReviewImage()で検索する）。 */
      "stars": 5,
      "quote": "機能もデザインも色も良い！ 買って良かったです。",
      "product": "ネオン パステル バイカラー",
      "url": "https://casebypca.com/products/230912",
      "image": "https://cdn.shopify.com/s/files/1/0746/6011/8782/files/S3e571d342b6041a1b618e529bf503e380.webp?v=1778527187"
    }
  ]
  // <<< REVIEWS_AUTO <<<
,

  /* #PCAのある暮らし ギャラリー用の手動キュレーションリスト（2026-09-24追加）。
     PRODUCTS（f-data.js・curated_products.jsonから自動生成・手編集禁止）は
     並び順・件数が再生成のたびに変わりうるため、掲載可否は配列の位置ではなく
     ここに列挙した product の handle（変わらない識別子）で管理する。
     f-app.js はこの handle に一致する PRODUCTS の image だけをプール化し、
     日替わりで6枚を自動選出する（詳細はf-app.jsのPCA_LIFE_IMAGE_POOL参照）。

     選定基準：実際にケースを持っている写真／手元・コーデ・日常の中で使っている写真／
     複数ケースを並べたSNS向きの写真／PCAの世界観が伝わるライフスタイル写真のみ採用。
     以下は目視確認のうえ対象外とした（2026-09-24時点のPRODUCTS 60件中4件）：
       - 260044（3Dフィッシュボーン）: 白背景・スペック訴求の販促テキストが
         画像に焼き込まれた商品説明用画像
       - 260042（ウォーターリップル バンパー）: 手や生活感の無い白背景の商品単体画像
       - 260035（コントラストカラー クリアケース）: 小物と光でスタイリングした
         スタジオ撮影の商品写真で、人物・生活シーンが無い
       - 230704（ウチのコCASE ステッカー風）: 別ブランドロゴの透かしが入った
         商品ラインの販促用フラットレイ

     今後ライフスタイル画像を追加したい場合は、対象商品の handle を
     この配列に1行追加するだけでよい（PRODUCTSに実在するhandleであること）。
     現時点の候補はこの56件（元の固定6枚「260059/260058/260057/260056/260055/260054」を含む）。 */
  "PCA_LIFE_GALLERY_HANDLES": [
    "かわいい動物デザイン-iphoneケース-耐衝撃-動物イラスト-260066",
    "polka-dots-cute-3d-cartoon-dog-stand-hodler-phone-case-for-iphone-17-pro-max-16-15-14-13-pro-max-plus-cover-with-lanyard-stand",
    "250916",
    "260064",
    "ポップでカラフルな3dフルーツデザイン-iphoneケース-軽量で持ちやすいデザイン-260063",
    "260062",
    "260061",
    "260060",
    "260059",
    "260058",
    "260057",
    "260056",
    "260055",
    "260054",
    "260053",
    "260052",
    "260051",
    "260050",
    "260049",
    "260048",
    "260047",
    "260046",
    "260043",
    "260041",
    "260039",
    "260038",
    "260037",
    "260036",
    "260034",
    "260033",
    "260032",
    "260031",
    "260030",
    "260029",
    "260028",
    "260027",
    "260026",
    "260025",
    "260024",
    "260023",
    "260022",
    "260021",
    "260020",
    "260019",
    "260018",
    "260017",
    "230705",
    "260016",
    "260015",
    "260014",
    "260013",
    "260012",
    "260011",
    "260010",
    "260009",
    "260008"
  ]
};
